type Maybe<T> = T | null;

type Region = {
  mesoRegion?: Maybe<string> | undefined;
  legionRegion?: Maybe<string> | undefined;
  macroRegion?: Maybe<string> | undefined;
};

export const formatRegions = (region: Region, domain: string, maxAge: number) => [
  {
    key: 'mesoRegion',
    value: region.mesoRegion,
    opt: { maxAge, domain },
  },
  {
    key: 'legionRegion',
    value: region.legionRegion,
    opt: { maxAge, domain },
  },
  {
    key: 'macroRegion',
    value: region.macroRegion,
    opt: { maxAge, domain },
  },
];
